import { Videos } from '../_app/cuchillo/components/Videos';
import { Acordions } from '../_app/cuchillo/components/Acordions';
import { Basics, isTouch } from '../_app/cuchillo/core/Basics';
import Forms from '../_app/cuchillo/forms/FormValidator';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scrollbar from '../_app/cuchillo/scroll/Scrollbar';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Keyboard from '../_app/cuchillo/core/Keyboard';
// import Scene from '../3D/Scene';
import Cmp from '../windows/Cmp';
import { GetBy } from '../_app/cuchillo/core/Element';
import { TitularMagneticController, TitularMagneticReveal } from '../components/TitularMagneticReveal';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import gsap from 'gsap';

export default class Default extends Page {
  title;
  _header;

  constructor() {
    super();

    Videos.init();
    Acordions.init();
    Forms.init();

    this._header = GetBy.class("header-page", this.container)[0];

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.addEventListener(Basics.clickEvent, Cmp._calls.click);
    });

    Footer.hide();

    if(!this.container.classList.contains("contact")) {
      if (this.container.dataset.logo == "black") Footer.goBlack(true);
      else Footer.goGrey(true);
    }
    
    TitularMagneticController.init();
  }

  //SHOW
  beforeShow() {
    super.beforeShow();
    Scroll.init();
    Keyboard.mountPage(this.id);
  }

  show__effect(__call) {
    Scroll.updateItems();

    if (this.isFirstTime) {
      Wrap.show(() => {
        Preloader.hide(() => { this.afterShow() });
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }
  }

  afterShow() {
    if(this._header) gsap.to(this._header,{opacity:1, duration:.2, delay:this.isFirstTime? .5 : 0});
    super.afterShow();
    Scroll.start();
    Scroll.show();
  }

  //HIDE
  beforeHide() {
    Keyboard.unmountPage(this.id);
    super.beforeHide();
  }

  hide__effect() {
    Scroll.hide();
    Wrap.hide(() => { this.afterHide(); });
  }

  afterHide() {
    Scroll.dispose();

    [...GetBy.selector('[data-toggle-cmp]')].map(item => {
      item.removeEventListener(Basics.clickEvent, Cmp._calls.click);
    });

    super.afterHide();
  }

  //RESIZE
  resize() {
    super.resize();
    Acordions.resize();
  }

  //LOOP
  loop() {
    if (this._isActive) {
      super.loop();
    }
  }
}

ControllerPage._addPage('default', Default);
